import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {BrowserModule} from '@angular/platform-browser';
import {FormsModule} from '@angular/forms';
import {EffectsModule} from '@ngrx/effects';
import {MatLegacyButtonModule as MatButtonModule} from '@angular/material/legacy-button';
import {MatLegacyFormFieldModule as MatFormFieldModule} from '@angular/material/legacy-form-field';
import {MatLegacyInputModule as MatInputModule} from '@angular/material/legacy-input';
import {MatIconModule} from '@angular/material/icon';
import {MatLegacyProgressSpinnerModule as MatProgressSpinnerModule} from '@angular/material/legacy-progress-spinner';

import {LoginComponent} from './login.component';
import {LoginService} from './login.service';
import {LoginEffects} from './login.effects';
import {TranslateModule} from '@ngx-translate/core';
import {AutoFocusModule} from '../directive/autofocus/autofocus.module';
import {RecaptchaModule} from '../directive/recaptcha/recaptcha.module';
import {SessionStorageService} from '../../domain/common/services/session-storage.service';
import {PleaseWaitModule} from "../component/please-wait/please-wait.module";

@NgModule({
    imports: [BrowserModule, RouterModule, FormsModule, TranslateModule, MatButtonModule, MatIconModule, MatFormFieldModule, MatInputModule, EffectsModule.forFeature([LoginEffects]), AutoFocusModule, MatProgressSpinnerModule, RecaptchaModule, PleaseWaitModule],
    declarations: [LoginComponent],
    exports: [LoginComponent],
    providers: [LoginService,SessionStorageService]
})
export class LoginModule {}